import React from 'react'
import { Row } from 'react-styled-flexboxgrid'

import { FadeIn, Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import Content from './Content'

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
`

class ErrorWithResponse extends Error {
  public response: any
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  }
  const error: ErrorWithResponse = new ErrorWithResponse(response.statusText)
  error.response = response
  throw error
}

class ZestyClient {
  public baseURL: string

  constructor(baseURL) {
    this.baseURL = baseURL
  }

  public getArticle(id): Promise<Article> {
    const baseURL = `${this.baseURL}-/custom/article.json?uuid=${id}`
    return fetch(baseURL, null)
      .then(checkStatus)
      .then((response) => response.json())
  }
}

export const getZestyData = (id, env) => {
  const grow = new ZestyClient(env.get('grow'))

  return grow.getArticle(id).then((article) => {
    return article
  })
}

const SpinnerContainer = styled.div`
  margin: 0 auto;
  background: white;
  height: calc(100vh - 80px);
  display: flex;
  align-content: center;
`

const GrowArticle = (props) => {
  return (
    <FadeIn>
      <Container data-testid={'GROW_ARTICLE_CONTENT'}>
        {props.articleLoading && (
          <SpinnerContainer>
            {' '}
            <Spinner />
          </SpinnerContainer>
        )}
        {!props.articleLoading && (
          <Row>
            <Content article={props.currentArticle} showUpNext={false} />
          </Row>
        )}
      </Container>
    </FadeIn>
  )
}

export default GrowArticle
